module.exports = "/assets/delice-page/hero@2x.jpg?6+Cvigi";